module.exports = __webpack_public_path__ + "static/media/OneTimePurchaseIcon.54ce36ee.svg";